import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "font-weight-bold mb-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "alert alert-info alert-styled-left alert-arrow-left alert-dismissible" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "close",
    "data-dismiss": "alert"
  }, [
    /*#__PURE__*/_createElementVNode("span", null, "×")
  ]),
  /*#__PURE__*/_createTextVNode(" Wenn Sie Accounts verknüpfen, können Sie direkt in diesen Account wechseln, ohne nochmalige Eingabe der Zugangsdaten. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Sie übernehmen dabei alle Rechte und Sichten des Nutzers zu dem Sie wechseln. ")
], -1)
const _hoisted_4 = { class: "card" }
const _hoisted_5 = { class: "card-header header-elements-inline" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h6", { class: "card-title" }, "Verwalten Sie Ihre Accounts", -1)
const _hoisted_7 = { class: "header-elements" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "icon-plus2" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Neuen Account verknüpfen")
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = { class: "media-list media-list-linked media-list-bordered" }
const _hoisted_12 = { class: "media align-items-center disabled" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "mr-1 mr-md-3 d-flex flex-column align-items-center" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "#",
    class: "btn bg-transparent rounded-pill text-dark border-dark border-2 btn-icon ml-2 mr-2 ml-md-3 mr-md-3"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "icon-user" })
  ])
], -1)
const _hoisted_14 = { class: "media-body" }
const _hoisted_15 = { class: "mr-3" }
const _hoisted_16 = { class: "text-muted" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "mr-3 font-size-lg text-uppercase d-none d-md-block" }, " Bereits eingeloggt ", -1)
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "mr-1 mr-md-3 d-flex flex-column align-items-center" }
const _hoisted_20 = { class: "media-body d-flex flex-column overflow-hidden" }
const _hoisted_21 = { class: "mr-3 text-opac-right" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { class: "mr-3" }
const _hoisted_24 = { class: "text-muted text-opac-right" }
const _hoisted_25 = { class: "ml-3" }
const _hoisted_26 = { class: "list-icons" }
const _hoisted_27 = { class: "btn-group d-md-none" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("button", {
  href: "#",
  type: "button",
  class: "btn btn-sm btn-icon",
  "data-toggle": "dropdown"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon-more2" })
], -1)
const _hoisted_29 = { class: "dropdown-menu dropdown-menu-right" }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = ["onClick"]
const _hoisted_32 = ["onClick"]
const _hoisted_33 = /*#__PURE__*/_createElementVNode("i", { class: "icon-enter" }, null, -1)
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = ["onClick"]
const _hoisted_36 = /*#__PURE__*/_createElementVNode("i", { class: "icon-unlink" }, null, -1)
const _hoisted_37 = [
  _hoisted_36
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.headline), 1),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("button", {
            class: "btn btn-accent btn-sm",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.linkAccount && _ctx.linkAccount(...args)))
          }, _hoisted_10)
        ])
      ]),
      _createElementVNode("ul", _hoisted_11, [
        _createElementVNode("li", null, [
          _createElementVNode("a", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.user.firstName) + " " + _toDisplayString(_ctx.user.lastName), 1),
              _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.user.email), 1)
            ]),
            _hoisted_17
          ])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accounts, (acc, index) => {
          return (_openBlock(), _createElementBlock("li", {
            key: index,
            class: ""
          }, [
            _createElementVNode("a", {
              class: "media cursor-pointer align-items-center p-2",
              onClick: _withModifiers(($event: any) => (_ctx.changeAccount(acc, $event)), ["prevent"])
            }, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("a", {
                  href: "#",
                  class: _normalizeClass(["btn bg-transparent rounded-pill border-2 btn-icon ml-2 mr-2 ml-md-3 mr-md-3", ['text-'+_ctx.userStatus[acc.status].class, 'border-'+_ctx.userStatus[acc.status].class]])
                }, [
                  _createElementVNode("i", {
                    class: _normalizeClass(acc.icon)
                  }, null, 2)
                ], 2),
                _createElementVNode("small", {
                  class: _normalizeClass(["mx-auto", 'text-'+_ctx.userStatus[acc.status].class])
                }, _toDisplayString(_ctx.userStatus[acc.status].name), 3)
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("span", _hoisted_21, [
                  _createTextVNode(_toDisplayString(acc.firstName) + " " + _toDisplayString(acc.lastName) + " ", 1),
                  (acc.account!=='')
                    ? (_openBlock(), _createElementBlock("small", _hoisted_22, " ( " + _toDisplayString(acc.account) + " )", 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("span", _hoisted_23, [
                  _createElementVNode("i", {
                    class: _normalizeClass(["icon-envelop", acc.invitation == 1 ? 'text-primary' : 'text-secondary'])
                  }, null, 2),
                  _createElementVNode("i", {
                    class: _normalizeClass(["icon-user-check ml-2", acc.verified == 1 ? 'text-primary' : 'text-secondary'])
                  }, null, 2)
                ]),
                _createElementVNode("div", _hoisted_24, _toDisplayString(acc.email), 1)
              ]),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _hoisted_28,
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("a", {
                        href: "#",
                        class: "dropdown-item",
                        onClick: _withModifiers(($event: any) => (_ctx.changeAccount(acc)), ["stop"])
                      }, " Einloggen", 8, _hoisted_30),
                      _createElementVNode("a", {
                        href: "#",
                        class: "dropdown-item",
                        onClick: _withModifiers(($event: any) => (_ctx.unlinkAccount(acc)), ["stop"])
                      }, " Trennen", 8, _hoisted_31)
                    ])
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn bg-secondary-100 text-secondary d-none d-md-block",
                    onClick: _withModifiers(($event: any) => (_ctx.changeAccount(acc)), ["stop"])
                  }, _hoisted_34, 8, _hoisted_32),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn bg-danger-100 text-danger d-none d-md-block",
                    onClick: _withModifiers(($event: any) => (_ctx.unlinkAccount(acc)), ["stop"])
                  }, _hoisted_37, 8, _hoisted_35)
                ])
              ])
            ], 8, _hoisted_18)
          ]))
        }), 128))
      ])
    ])
  ]))
}